<template>
    <Card>
        <template v-slot:header>
            <h2>高峰时段</h2>
            <span class="icon-info">&nbsp;</span>
        </template>
        <div class="card-content">
            <ChartMap class="chart-small" ref="chart"></ChartMap>
        </div>
    </Card>
</template>
<script>
import ChartMap from "../../components/ChartMap.vue";
export default {
    name: "PeakPeriod",
    components: { ChartMap },
    data() {
        return {
            dayList: [],
            hourList: [],
            dataList: [],
            maxData: 100,
        };
    },
    mounted() {},
    methods: {
        setData(data) {
            data.EntityID = data.ID;
            data.EndTime = data.BeginTime;
            data.Date = data.BeginTime;
            this.$ajax.post("/FlowData/GetPeakPeriod", data).then((result) => {
                let arrDays = [];
                let arrHours = [];
                let data = [];
                let idx1 = 0;
                let idx2 = 0;
                let max = 100;
                for (let i = 0; i < result.Data.length; i++) {
                    let mdl = result.Data[i];
                    if (arrDays.filter((r) => r == mdl.Name).length == 0) {
                        arrDays.push(mdl.Name);
                        idx1 = arrDays.length - 1;
                        idx2 = 0;
                    }
                    data.push([idx1, idx2, mdl.DataIn, mdl.DataOut]);
                    max = Math.max(max, mdl.DataIn);
                    idx2++;
                    if (arrHours.filter((r) => r == mdl.ChildName).length == 0) {
                        arrHours.push(mdl.ChildName);
                    }
                }
                this.dayList = arrDays;
                this.hourList = arrHours;
                this.dataList = data;
                this.maxData = max;

                let opt = this.getOptions();
                this.$refs.chart.setData(opt, true);
            });
        },
        getOptions() {
            var days = this.dayList;
            var hours = this.hourList;
            var data = this.dataList;
            data = data.map(function (item) {
                return [item[1], item[0], item[2] || "-", item[3] || "-"];
            });
            let option = {
                tooltip: {
                    position: "top",
                    formatter(p, ticket, callback) {
                        console.log(p);
                        let str = p.name + "<br />";
                        str += "入园：" + p.data[2] + "    ";
                        str += "出园：" + p.data[3];
                        return str;
                    },
                },
                grid: {
                    height: "80%",
                    top: "10%",
                    left: "50px",
                    right: "10px",
                },
                xAxis: {
                    type: "category",
                    data: hours,
                    splitArea: {
                        show: true,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    type: "category",
                    data: days,
                    splitArea: {
                        show: true,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                visualMap: {
                    min: 0,
                    max: this.maxData,
                    calculable: true,
                    orient: "horizontal",
                    right: "10px",
                    top: "0px",
                    itemWidth: "10px",
                    itemHeight: "150px",
                    textGap: 20,
                    inRange: {
                        color: ["#8dc97c", "#fcea83", "#fd933d", "#ff706e"],
                    },
                },
                series: [
                    {
                        name: "客流量",
                        type: "heatmap",
                        data: data,
                        label: {
                            show: true,
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };
            return option;
        },
    },
};
</script>
